import './osasReferral/register';
import './osasQuestionnaires/register';
import './osasZorgDomeinReferral/register';
import './osasLifeStyleForm/register';
import './osasRequestAdditionalExamination/register';
import './osasCloudPatExamination/register';
import './osasCloseUnfinishedExamination/register';
import './osasTreatmentChoice/register';
import './osasConsult/register';
import './osasEvaluation/register';
import './osasMraLetter/register';
import './osasResendPatientInvite/register';
import './osasExternalReferralLetter/register';
import './osasResendMijnKsyosQuestionnaires/register';
import './osasFollowUpConsult/register';
import './osasCloudPatFollowUpExamination/register';
import './osasRequestFollowUpExamination/register';
import './osasCloseUnfinishedFollowUpExamination/register';
import './osasCpapChosen/register';
